var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectingClassroom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 229,
    viewBox: "0 0 256 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.145 87.0945V155.905H12.4316V19.5859H129.144",
    stroke: "#9FA5B4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2666 155.612C15.2666 155.612 15.4964 146.192 25.8976 141.075C31.1059 138.517 43.7437 135.683 55.0793 133.416",
    stroke: "#9FA5B4",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1094 133.479C109.583 135.684 122.359 138.518 127.551 141.138C137.953 146.254 138.183 155.675 138.183 155.675",
    stroke: "#9FA5B4",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.68 129.222V139.868C97.68 139.868 91.3382 144.893 76.7244 144.893C62.1105 144.893 55.9219 139.868 55.9219 139.868V92.9629",
    stroke: "#9FA5B4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8457 95.5215C55.8457 122.467 74.4883 127.353 79.3136 129.115C85.8699 131.52 93.6058 131.566 99.5187 127.215C104.434 123.316 108.024 117.992 109.797 111.974C111.472 106.648 112.289 101.089 112.218 95.5062V66.9219",
    stroke: "#9FA5B4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.815 48.8891C105.031 43.5123 97.7704 39.0547 84.0297 39.0547C76.11 39.0547 67.1028 39.0547 65.2799 49.0424C55.2156 47.9088 55.8437 56.7016 55.8437 56.7016V82.0078C55.8437 82.0078 62.8289 82.4673 64.039 75.7425V71.9129C64.2598 70.6041 64.9453 69.4188 65.9695 68.5746C66.9938 67.7305 68.2881 67.2841 69.615 67.3173H70.1052C70.1052 67.3173 77.0291 67.8075 78.224 61.0827C79.4341 67.8075 86.4194 67.348 86.4194 67.348L112.262 67.2407C112.262 67.2407 114.529 55.8744 108.815 48.8891Z",
    stroke: "#9FA5B4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0508 92.7303H55.0637C53.7013 92.6572 52.4188 92.0645 51.4803 91.0742C50.5417 90.084 50.0186 88.7715 50.0186 87.4071C50.0186 86.0427 50.5417 84.7304 51.4803 83.7401C52.4188 82.7498 53.7013 82.1571 55.0637 82.084H58.0508",
    stroke: "#9FA5B4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.524 11.6035H8.12739C6.50231 11.6035 4.94378 12.2491 3.79467 13.3982C2.64556 14.5473 2 16.1058 2 17.7309V177.901C2 179.526 2.64556 181.085 3.79467 182.234C4.94378 183.383 6.50231 184.028 8.12739 184.028H241.796C243.421 184.028 244.979 183.383 246.128 182.234C247.277 181.085 247.923 179.526 247.923 177.901V81.7315",
    stroke: "#9FA5B4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.775 169.919C128.775 170.678 128.55 171.419 128.129 172.049C127.708 172.679 127.108 173.17 126.408 173.459C125.707 173.748 124.936 173.823 124.193 173.674C123.45 173.525 122.767 173.159 122.232 172.622C121.697 172.085 121.334 171.401 121.188 170.657C121.042 169.913 121.12 169.143 121.412 168.443C121.704 167.744 122.198 167.147 122.829 166.728C123.461 166.309 124.203 166.087 124.961 166.09C125.463 166.09 125.961 166.189 126.424 166.382C126.888 166.574 127.309 166.857 127.664 167.212C128.018 167.568 128.299 167.991 128.49 168.455C128.68 168.92 128.777 169.417 128.775 169.919V169.919Z",
    stroke: "#9FA5B4",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M154.802 217.194H95.1211L99.1958 184.045H150.712L154.802 217.194Z",
    stroke: "#9FA5B4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M183.662 217.305H66.2607V227.001H183.662V217.305Z",
    stroke: "#9FA5B4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M130.031 67.9001V21.6076C130.035 16.4086 132.102 11.4237 135.779 7.74742C139.455 4.07115 144.44 2.00406 149.639 2H234.013C239.213 2 244.201 4.06579 247.878 7.74293C251.555 11.4201 253.621 16.4074 253.621 21.6076V67.9001C253.617 73.0978 251.549 78.0811 247.872 81.7549C244.196 85.4288 239.211 87.4924 234.013 87.4924H188.058L134.121 113.457L148.842 87.4159C143.795 87.2182 139.019 85.0771 135.513 81.44C132.007 77.803 130.043 72.9517 130.031 67.9001Z",
    stroke: "#9FA5B4",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M180.169 43.8522C180.172 44.6413 179.94 45.4134 179.504 46.0707C179.067 46.728 178.446 47.2409 177.717 47.5442C176.989 47.8476 176.187 47.9277 175.413 47.7745C174.639 47.6213 173.928 47.2417 173.37 46.6838C172.812 46.1258 172.432 45.4148 172.279 44.6408C172.126 43.8668 172.206 43.0647 172.509 42.3363C172.813 41.6079 173.325 40.986 173.983 40.5496C174.64 40.1131 175.412 39.8818 176.201 39.8848C177.253 39.8848 178.263 40.3027 179.007 41.0468C179.751 41.7908 180.169 42.8 180.169 43.8522Z",
    fill: "#9FA5B4",
    stroke: "#9FA5B4",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M195.795 43.8522C195.798 44.6406 195.567 45.4121 195.131 46.0691C194.695 46.7261 194.074 47.2389 193.347 47.5427C192.619 47.8465 191.818 47.9276 191.044 47.7757C190.271 47.6237 189.56 47.2457 189.001 46.6893C188.443 46.1329 188.062 45.4232 187.907 44.6502C187.752 43.8772 187.83 43.0756 188.131 42.3469C188.432 41.6182 188.942 40.9953 189.598 40.557C190.253 40.1187 191.024 39.8848 191.812 39.8848C192.866 39.8848 193.876 40.3022 194.623 41.0458C195.369 41.7894 195.791 42.7986 195.795 43.8522Z",
    fill: "#9FA5B4",
    stroke: "#9FA5B4",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M211.035 43.8522C211.038 44.6406 210.807 45.4121 210.371 46.0691C209.935 46.7261 209.314 47.2389 208.587 47.5427C207.859 47.8465 207.058 47.9276 206.285 47.7757C205.511 47.6237 204.8 47.2457 204.241 46.6893C203.683 46.1329 203.302 45.4232 203.147 44.6502C202.992 43.8772 203.07 43.0756 203.371 42.3469C203.672 41.6182 204.183 40.9953 204.838 40.557C205.493 40.1187 206.264 39.8848 207.052 39.8848C208.106 39.8848 209.117 40.3022 209.863 41.0458C210.609 41.7894 211.031 42.7986 211.035 43.8522Z",
    fill: "#9FA5B4",
    stroke: "#9FA5B4",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectingClassroom);
export default __webpack_public_path__ + "static/media/connectingClassroom.5ca5944d.svg";
export { ForwardRef as ReactComponent };